import React from 'react';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';

/**
 * Compact right-rail widget. Title row with optional action, then children.
 * Used by MyNetwork and (later) SocialFeed for the right-rail panels.
 */
const SideWidget = ({ icon, title, actionLabel, onAction, className = 'mb-3', children }) => (
    <Card
        className={`shadow-1 ${className}`}
        pt={{ body: { className: 'p-3' }, content: { className: 'p-0' } }}
    >
        <div className="flex align-items-center justify-content-between mb-2 gap-2">
            <div className="flex align-items-center gap-2 min-w-0">
                {icon && <i className={`pi ${icon} text-primary`} aria-hidden="true" />}
                <h4 className="text-900 font-semibold text-sm m-0 white-space-nowrap overflow-hidden text-overflow-ellipsis">
                    {title}
                </h4>
            </div>
            {actionLabel && (
                <Button label={actionLabel} text size="small" onClick={onAction} />
            )}
        </div>
        {children}
    </Card>
);

export default SideWidget;
